import React, { useState, useEffect } from "react";
import { FaPlus, FaEdit, FaTrashAlt, FaUpload, FaTimes } from 'react-icons/fa'
import Button from "../../../DynamicComp/Button";
import GenericTable from "../../../DynamicComp/Table";
import Input from "../../../DynamicComp/Input";
import Selector from "../../../DynamicComp/Selector";
import Productmasterimg from "./Productmasterimg";
import axiosClient , { deleteData, getData, postData, putData, getBaseUrl  } from "../../../../global/Globalapi";
import Selectornew from "../../../DynamicComp/Selectornew";
import Inputfield from "../../../DynamicComp/Inputfield";
import Step3 from "../../../DynamicComp/Step3";
//import { encodeId } from "../../../../global/Globalapi";
import axios from 'axios';
import Step4 from "../../../DynamicComp/Step4";
import { renderMatches } from "react-router-dom";
import Editproductmaster from "./Editproductmaster";
import { showAlert } from "../../../DynamicComp/Alert";
import { encodeId } from "../../../../global/Globalfunction";

const ProductMaster = () => {
    const [productdata, setData] = useState([]);
    const [categoryselect,setCategoryselect]=useState();
    const [product_typedata, setPdtData] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [editId, setEditId] = useState(null);
    const [iseditid,setiseditid] = useState(null);
    const [isedit,setisedit]=useState(false);
    const[mastereditid,setmastereditid]=useState(null);
    const [childImages, setChildImages] = useState([]);
    const [productComponents, setProductComponents] = useState([]);
    const [componentValues, setComponentValues] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [activeStep, setActiveStep] = useState(1);
    const [newrender,setnewrender] = useState(false);
    const [activePriceCard, setActivePriceCard] = useState(0);
    useEffect(() => {
        if (activeStep !== 2) {
            setActivePriceCard(null);
        }
    }, [activeStep]);

    const [groupId, setSelectedGroupId] = useState('');
    const[attribute,setattribute]=useState([]);
    const [error, setError] = useState(null);
    const [hasVariant, setHasVariant] = useState(false);
    const [productAttrsWithOpts, setProductAttrsWithOpts] = useState([]);
    const [variantAttrsWithOpts, setVariantAttrsWithOpts] = useState([]);
    const[selectedvalues,setSelectedvalues]=useState([]);
    const[newproductid,setNewProductId]=useState();
    const[combos,setCombos]=useState([]);
    const [category,setcategory]=useState([]);
    const [data,setdata] = useState({});
    const[response,setresponse] = useState({});
const [regionData, setRegionData] = useState([]);
const [branchData, setBranchData] = useState([]);
const [regionSelect, setRegionSelect] = useState("");
const [branchSelect, setBranchSelect] = useState("");
  // const API_BASE_URL = "http://localhost:5000";
    const API_BASE_URL = getBaseUrl();
    const [with_or_without_gst,setwith_or_without_gst]=useState('withGST');
    const handleVariantSaveComplete = () => {
        setActiveStep(4);
}   ;

    
   
    const initialFormState = {
        groupName: '',
        category_name: '',
        productName: '',
        productCode: '',
        productModel: '',
        barCode: '',
        hsnSac: '',
        initial_stock: 0,
        purchasePriceIncludeGST: '',
        selling_Price: '',
        cgst_percent: 0,
        cgst: '',
        sgstPer: 0,
        sgst: '',
        igstPer: 0,
        igst: '',
        sellingPriceGST: '',
        discountPercent: 0,
        discountAmount: 0,  
        netPrice: '', 
        MRP: '',
        height: '',
        width:'',
        breadth:'',
        weight:'',
        hasVariant:false,
        description: '',
        options: selectedvalues,
        home_delivery: false,
home_delivery_amount: "",

take_away: false,
take_away_amount: "",

safe_delivery: false,
safe_delivery_amount: "",
 branch_id: "",
    };

    const [formData, setFormData] = useState(initialFormState);
    const inputClassName = "w-full px-2 py-1 text-sm border border-gray-300 rounded-md shadow-sm placeholder-gray-700";

    const fetchData = async () => {
        try {
            const response = await getData(`/product_type/all`);
            console.log("product group response data k7,",response)
            setPdtData(response.data);
        } catch (error) {
            console.error('Error fetching product groups:', error);
        }
    };
const fetchcategory = async() => {
    try {
        const res = await getData("/product_category/category")
        if(res) {
            console.log("Category response data", res)
            setcategory(res.data);
        }
    }
    catch(error) {
        console.log("Error fetching category", error);
    }
}
    // In your ProductMaster.js file, update the fetchProdMasData function:

const fetchProdMasData = async () => {
  try {
    console.log("🔄 Fetching products with expanded variants...");
    
    // Use the new endpoint
    const response = await getData("/products_with_expanded_variants");
    // Alternative: const response = await getData("/products_expanded_simple");
    
    console.log("✅ Received data:", response.data.length, "rows");
    
    // Log sample data for debugging
    if (response.data.length > 0) {
      const parents = response.data.filter(p => p.row_type === 'parent');
      const variants = response.data.filter(p => p.row_type === 'variant');
      console.log(`📊 Breakdown: ${parents.length} parents, ${variants.length} variants`);
      
      // Show a sample variant
      if (variants.length > 0) {
        console.log("Sample variant:", variants[0]);
      }
    }
    
    setData(response.data);
    
  } catch (error) {
    console.error('❌ Error fetching expanded products:', error);
    
    // Fallback to old endpoint
    try {
      const fallbackResponse = await getData("/product/addproduct");
      console.log("⚠️ Using fallback data:", fallbackResponse.data.length);
      setData(fallbackResponse.data);
    } catch (fallbackError) {
      console.error('Failed to fetch fallback data:', fallbackError);
      showAlert({
        type: 'error',
        message: 'Failed to load products',
        title: 'Error',
      });
    }
  }
};
    const fetchComponentsForGroup = async (groupId) => {
        try {
            const response = await getData(`/getComponentMap/${groupId}`);
            setProductComponents(response.data);
            const initialValues = {};
            response.data.forEach(comp => {
                initialValues[comp.attribute_id] = '';
            });
            setComponentValues(initialValues);
        } catch (error) {
            console.error('Error fetching components:', error);
            setProductComponents([]);
            setComponentValues({});
        }
    };

    // const fetchComponentValuesForProduct = async (productId) => {
    //     try {
    //         const response = await getData(`/product/${productId}`);
    //         if (response.data.components) {
    //             const values = {};
    //             response.data.components.forEach(comp => {
    //                 values[comp.attribute_id] = comp.comp_value;
    //             });
    //             setComponentValues(values);
    //         }
    //     } catch (error) {
    //         console.error('Error fetching component values:', error);
    //     }
    // };

    

const fetchComponentValuesForProduct = async (productId) => {
  try {
    // 🔥 Encrypt productId before sending
    const encryptedId = encodeId(productId);

    if (!encryptedId) {
      console.error("Failed to encode product ID");
      return;
    }

    // Call backend with encrypted ID
    const response = await getData(`/product/${encryptedId}`);

    if (response.data.components) {
      const values = {};
      response.data.components.forEach((comp) => {
        values[comp.attribute_id] = comp.comp_value;
      });
      setComponentValues(values);
    }
  } catch (error) {
    console.error("Error fetching component values:", error);
  }
};

// useEffect(() => {
//   fetchRegions();
// }, []);
// const fetchBranchesByRegion = async (regionId) => {
//   try {
//     const res = await axiosClient.get(`/api/branch/by-region/${regionId}`); 
//     setBranchData(res.data);
//   } catch (err) {
//     console.error("Failed to fetch branches:", err);
//   }
// };
//  const fetchRegions = async () => {
//     try {
//       const res = await axiosClient.get("/api/region");
//       setRegionData(res.data);
//     } catch (err) {
//       console.error("Failed to fetch regions:", err);
//     }
//   };
    
  const fetchRegions = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/regionmaster`
      );
      setRegionData(response.data);
    } catch (error) {
      console.error("Error fetching regions:", error);
    }
  };


const fetchBranchesByRegion = async (regionId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/branchmaster`
    );

    // ✅ Filter branches by selected region_id
    const filteredBranches = response.data.filter(
      (branch) => branch.region_id === parseInt(regionId)
    );

    setBranchData(filteredBranches);

  } catch (error) {
    console.error("Error fetching branches:", error);
  }
};
  // ✅ Load Regions on Page Load
  useEffect(() => {
    fetchRegions();
  }, []);

  // ✅ Load Branch when Region Changes
  useEffect(() => {
    if (regionSelect) {
      fetchBranchesByRegion(regionSelect);
    } else {
      setBranchData([]);
    }
  }, [regionSelect]);
useEffect(() => {
        fetchProdMasData();
    }, []);
    useEffect(() => {
     fetchcategory();
    }, [])
    useEffect(() => {
       fetchData();
    }, [categoryselect])
    useEffect(()=>{
        console.log("selected category",categoryselect);
    },[categoryselect])
        useEffect(() => {
          console.log('productAttrsWithOpts');
        console.log(productAttrsWithOpts);
        console.log('variantAttrsWithOpts')
        console.log(variantAttrsWithOpts);
    }, [attribute]);

    useEffect(() => {
        if (formData.groupName) {
            fetchComponentsForGroup(formData.groupName);
        } else {
            setProductComponents([]);
            setComponentValues({});
        }
    }, [formData.groupName]);

    const handleImagesUpdate = (updatedImages) => {
        setChildImages(updatedImages);
    };
useEffect(()=>{
    console.log("child images",childImages)
},[childImages])
useEffect(()=>{
   if(editId){
     handleEdit(editId)
   }
     
    
},[editId])
    const handleEdit = async (id) => { 
        let master =null
      const masterresponse=await getData(`/product_edit/${id}`)   
            
       if(masterresponse){
        console.log("masterresponse",masterresponse.data)
         master=masterresponse.data[0];
         console.log("master",master)
        setFormData({
            groupName: master.product_type_id || '',
            category_name: master.product_category_id || '',
            productName: master.product_name || '',
            productCode: master.product_code || '',
            productModel: master.product_model || '',
            barCode: master.bar_code || '',
            hsnSac: master.hsn_sac || '',
            initial_stock: master.initial_stock || '',
            purchasePriceIncludeGST: master.unit_purchase_price || '',
            selling_Price: master.unit_selling_price || '',
            cgst_percent: master.cgst_percent || '',
            cgst: master.cgst_percent || '',
            sgstPer: master.sgst_percent || '',
            sgst: master.sgst_percent || '',
            igstPer: master.igst_percent || '',
            igst: master.igst_percent || '',
            sellingPriceGST: master.unit_selling_price_with_gst || '',
            discountPercent: master.discount_percent_rtl || '',
            discountDealerPer: master.discount_percent_ws || '',
            discountDealer: master.discount_amt_subdealer || '',
            discountSubDealerPer: master.discount_percent_subdealer || '',
            discountSubDealer: master.discount_amt_subdealer || '',
            discountRetailPer: master.discount_percent_rtl || '',
            discountRetail: master.discount_amt_rtl || '',
            netPriceDealer: master.net_price_ws || '',
            netPriceSubDealer: master.net_price_subdealer || '',
            netPriceRetail: master.net_price_rtl || '',
            MRP: master.mrp_price || '',
            initial_stock: master.initial_stock || '',
            height: master.height || '',
            width: master.width || '',
            breadth: master.breadth || '',
            weight: master.weight || '',
            region_id: master.region_id ? String(master.region_id) : '',
            branch_id: master.branch_id ? String(master.branch_id) : '',
            home_delivery: master.home_delivery === 1,
            home_delivery_amount: master.home_delivery_amount || "",

            take_away: master.take_away === 1,
            take_away_amount: master.take_away_amount || "",

            safe_delivery: master.safe_delivery === 1,
            safe_delivery_amount: master.safe_delivery_amount || "",
        });
console.log("🚚 Delivery flags from backend:", {
  home_delivery: master.home_delivery,
  take_away: master.take_away,
  safe_delivery: master.safe_delivery,
});
setRegionSelect({
  value: master.region_id,
  label: master.region_name
});

setBranchSelect({
  value: master.branch_id,
  label: master.branch_name
});

        if (master?.product_type_id) {
            await fetchComponentsForGroup(master.product_type_id);
        }

        if (master?.product_id) {
            await fetchComponentValuesForProduct(master.product_id);
            try {
                const response = await getData(`/product_images/${master.product_id}`);
                const formattedImages = response.data.map(img => ({
                    id: img.image_id,
                    file_name: img.file_name,
                    displayOrder: img.display_order,
                    description: img.description,
                    file: null
                }));
                setChildImages(formattedImages);
            } catch (error) {
                console.error('Error fetching images:', error);
                setChildImages([]);
            }
        }}

        setEditId(master.product_id);
        setShowForm(true);
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this product master?')) return;

        try {
            const response = await deleteData(`/product/${id}`);
            showAlert({
    type: 'success',
    message: response.data.message || 'Product master deleted successfully.',
    title: 'success',
  });

            fetchProdMasData();
        } catch (error) {
             showAlert({
                              type: 'error',
                              message: data.message || "Failed to delete product master.",
                              title: 'error',
                            });
        }
    };

    const handleCancel = () => {
        setFormData(initialFormState);
        setEditId(null);
        setShowForm(false);
        setChildImages([]);
        setComponentValues({});
    };

    const handleChange = (e) => {
        const { name, type, value, checked } = e.target;
        setFormData({ ...formData, [name] : value });
    };

    const handleChangeGstradio = (e) => {
        const { name, value } = e.target;
        setwith_or_without_gst(value)

    }

    const handleComponentChange = (compId, value) => {
        setComponentValues(prev => ({
            ...prev,
            [compId]: value
        }));
    };

 const calculatePercentageAmount = (baseValue, percentage) => {
        const numericBase = parseFloat(baseValue) || 0;
        const numericPercent = parseFloat(percentage) || 0;

        // The correct formula is (base * percent) / 100
        return (numericBase * numericPercent) / 100;
    };

    useEffect(() => {
        // Use the new function to calculate each GST amount individually.
        const calculated_cgst = calculatePercentageAmount(formData.selling_Price, formData.cgst_percent);
        const calculated_sgst = calculatePercentageAmount(formData.selling_Price, formData.sgstPer);
        const calculated_igst = calculatePercentageAmount(formData.selling_Price, formData.igstPer);

        // Sum the calculated GST amounts to get the total GST.
        const total_gst_amount = calculated_cgst + calculated_sgst + calculated_igst;
        
        // Add the total GST to the base selling price.

        if(with_or_without_gst == 'withGST')
        {
            var selling_price_with_gst = (parseFloat(formData.selling_Price) || 0) + total_gst_amount;
        }
        else{
            var selling_price_with_gst = (parseFloat(formData.selling_Price) || 0)
        }
        

        setFormData((prev) => ({
            ...prev,
            cgst: calculated_cgst.toFixed(2),
            sgst: calculated_sgst.toFixed(2),
            igst: calculated_igst.toFixed(2),
            sellingPriceGST: selling_price_with_gst.toFixed(2),
        }));
    }, [formData.selling_Price, formData.cgst_percent, formData.sgstPer, formData.igstPer]);

  useEffect(() => {
        // Calculate the discount amount based on the Selling Price with GST and the new discountPercent field.
        const calculatedDiscount = calculatePercentageAmount(formData.sellingPriceGST, formData.discountPercent);
        
        const basePriceWithGst = parseFloat(formData.sellingPriceGST) || 0;

        // Calculate the final net price.
        const calculatedNetPrice = basePriceWithGst - calculatedDiscount;

        setFormData((prev) => ({
            ...prev,
            discountAmount: calculatedDiscount.toFixed(2),
            netPrice: calculatedNetPrice.toFixed(2),
        }));
    }, [formData.sellingPriceGST, formData.discountPercent]); // It now only depends on these two values.
    const handleSubmit = async (e) => {
        e.preventDefault();
       
    

        // Validate required fields
        if (!formData.groupName || !formData.productName) {
            showAlert({
                      type: 'warning',
                      message: data.message || 'Product Group and Product Name are required',
                      title: 'warning',
                    });
            return;
        }

        if (!formData.category_name) {
             showAlert({
                      type: 'warning',
                      message: data.message || 'Product category required',
                      title: 'warning',
                    });
            return;
        }

        try {
            const formDataToSend = new FormData();

            // Add all form data (including empty values)
            Object.keys(formData).forEach((key) => {
                formDataToSend.append(key, formData[key] || '');
            });

            // Prepare components data
            const componentsData = productComponents.map(comp => ({
                attribute_id: comp.attribute_id,
                comp_value: componentValues[comp.attribute_id] || ''
            }));
            formDataToSend.append('components', JSON.stringify(componentsData));

            // Prepare image data
            const imagesData = childImages.map((image, index) => ({
                originalName: image.file.name,
                displayOrder: image.displayOrder || index + 1,
                description: image.description || '',
                isNew: !image.id // Mark if it's a new image
            }));
            formDataToSend.append('images_data', JSON.stringify(imagesData));

            // Add image files for new images only
            childImages.forEach((image) => {
                if (image.file instanceof File) {
                    formDataToSend.append('image_files', image.file);
                }
            });

            console.log('Submitting data:', {
                formData: Object.fromEntries(formDataToSend),
                components: componentsData,
                images: imagesData
            });

            let response;
            const url = editId
                ? `/product_update/${editId}`
                : '/product_add';

            const method = editId ? 'put' : 'post';

            response = await axiosClient[method](url, formDataToSend, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

        
            showAlert({
                        type: 'success',
                     message: response.data.message || 'Operation completed successfully ✅',
                        title: 'success',
                        });
            fetchProdMasData();
            handleCancel();
        } catch (error) {
            console.error('Submission error:', error);
            showAlert({
                 type: 'error',
                 message: error.response?.data?.message ||
                error.message ||
                'Operation failed! Please check console for details.',
              title: 'error',
                 });

            
        }
        setIsSubmitting(false);
    };

    const columns = [
  { 
    key: "sno", 
    label: "S.No", 
    align: "center", 
    width: "80px",
    render: (row, index) => index + 1
  },
  { 
    key: "product_type_name", 
    label: "Product Type", 
    sortable: false 
  },
  { 
    key: "display_name", 
    label: "Product Name", 
    sortable: false,
    render: (row) => (
      <div className={`${row.is_variant ? 'pl-6' : ''}`}>
        {row.is_variant && (
          <span className="inline-block w-4 mr-2 text-gray-400">↳</span>
        )}
        <span className={`${row.is_variant ? 'text-gray-600' : 'font-medium'}`}>
          {row.display_name || row.product_name}
        </span>
        {row.is_parent && row.has_variant && (
          <span className="ml-2 text-xs px-2 py-0.5 bg-blue-100 text-blue-800 rounded-full">
            Has variants
          </span>
        )}
      </div>
    )
  },
  { 
    key: "product_code", 
    label: "Product Code", 
    sortable: false 
  },
  // { 
  //   key: "product_model", 
  //   label: "Product Model", 
  //   sortable: false 
  // },
   { 
  key: "region_name", 
  label: "Region", 
  sortable: false 
},
{ 
  key: "branch_name", 
  label: "Branch", 
  sortable: false 
},
  { 
    key: "initial_stock", 
    label: "Stock", 
    sortable: false, 
    align: "center",
    render: (row) => (
      <span className={`font-medium ${row.initial_stock <= 0 ? 'text-red-600' : 'text-gray-800'}`}>
        {row.initial_stock || 0}
      </span>
    )
  },
  { 
    key: "unit_selling_price", 
    label: "MRP", 
    sortable: false, 
    align: "right",
    render: (row) => (
      <span className="font-bold text-gray-900">
        ₹{parseFloat(row.unit_selling_price  || 0).toFixed(2)}
      </span>
    )
  },
  
  { 
    key: "actions", 
    label: "Actions",
    align: "center",
    width: "120px",
    render: (row) => (
      <div className="flex gap-2 justify-center">
        <button 
          className="bg-blue-500 hover:bg-blue-600 text-white p-2 rounded-lg transition-colors"
          onClick={() => { 
            setEditId(row?.product_id); 
            setmastereditid(row?.product_id);
          }}
          title="Edit Product"
        >
          <FaEdit size={16} />
        </button>
        <button 
          className="bg-red-500 hover:bg-red-600 text-white p-2 rounded-lg transition-colors"
          onClick={() => handleDelete(row?.product_id)}
          title="Delete Product"
        >
          <FaTrashAlt size={16} />
        </button>
      </div>
    )
  },
];
    const customRenderers = {
        actions: (row) => (
            <div className="flex gap-2 justify-center">
                <button className="bg-blue-500 text-white p-1 rounded" onClick={() =>{ setEditId(row?.product_id); setmastereditid(row?.product_id)}}>
                    <FaEdit />
                </button>
                <button className="bg-red-500 text-white p-1 rounded" onClick={() => handleDelete(row?.product_id)}>
                    <FaTrashAlt />
                </button>
            </div>
        ),
    };
// fetching attribute

useEffect(()=>{
  fetchattribute(groupId);
  setActivePriceCard(0);
  setHasVariant(false);
  
},[groupId])


// useEffect(()=>{
//   fetchoptions(groupId);
//   if(options && options.length > 0){
//    console.log('options');
//    console.log(options);
//   }
// },[groupId])
  useEffect(() => {
    if (attribute && attribute.length > 0) {
      console.log('Updated attribute:', attribute);
    }
     fetchOptions();
  }, [attribute]);
  // useEffect(()=>{
  //   console.log(formData);
  // },[hasVariant])
  useEffect(() => {
    // Update formData with selected values
    setFormData((prev) => ({
      ...prev,
      options: selectedvalues
    }));
  },[selectedvalues])
  useEffect(()=>{
    console.log('product group data');
    console.log(product_typedata);
  },[product_typedata]);
// const fetchoptions=async(groupId)=>{
//  if(!groupId){
//   setoptions([]);
//   setError('please select user group');
//   return;
//  }
//  try{
//   setError(null);
//   const res=await getData(`/productoption/${groupId}`)
//   console.log("options data")
//   console.log(res);
//   setoptions(res.data);
//  }catch(error){
//    setError(error.message || 'Error fetching options');
//  }
// }
const handleNextStep1 = async () => {
    // ✅ FIX 1: Validate required fields BEFORE trying to show alerts
    if (!formData.groupName || !formData.productName) {
        showAlert({
            type: 'warning',
            message: 'Product Group and Product Name are required',
            title: 'Warning',
        });
        return;
    }

    if (!formData.category_name) {
        showAlert({
            type: 'warning',
            message: 'Product Category required',
            title: 'Warning',
        });
        return;
    }

    try {
        const formDataToSend = new FormData();

        // Add required fields
        formDataToSend.append('groupName', formData.groupName);
        formDataToSend.append('category_name', formData.category_name);
        formDataToSend.append('productName', formData.productName);
        formDataToSend.append("branch_id", formData.branch_id);
        formDataToSend.append('description', formData.description || '');
        formDataToSend.append('hasVariant', formData.hasVariant);
// formDataToSend.append(
//   "home_delivery",
//   formData.home_delivery ? 1 : 0
// );
// formDataToSend.append(
//   "take_away",
//   formData.take_away ? 1 : 0
// );
// formDataToSend.append(
//   "safe_delivery",
//   formData.safe_delivery ? 1 : 0
// );
formDataToSend.append("home_delivery", formData.home_delivery ? 1 : 0);
formDataToSend.append("home_delivery_amount", formData.home_delivery_amount || 0);

formDataToSend.append("take_away", formData.take_away ? 1 : 0);
formDataToSend.append("take_away_amount", formData.take_away_amount || 0);

formDataToSend.append("safe_delivery", formData.safe_delivery ? 1 : 0);
formDataToSend.append("safe_delivery_amount", formData.safe_delivery_amount || 0);
        // ✅ FIX 2: Prepare image data with proper null checks
        const imagesData = childImages.map((image, index) => {
            // Check if image.file exists before accessing its properties
            if (image.file instanceof File) {
                return {
                    originalName: image.file.name,
                    displayOrder: image.displayOrder || index + 1,
                    description: image.description || '',
                    isNew: !image.id
                };
            }
            // For existing images
            return {
                originalName: image.file_name || `image_${index}`,
                displayOrder: image.displayOrder || index + 1,
                description: image.description || '',
                isNew: false
            };
        });

        formDataToSend.append('images_data', JSON.stringify(imagesData));

        // Add image files for new images only
        childImages.forEach((image) => {
            if (image.file instanceof File) {
                formDataToSend.append('image_files', image.file);
            }
        });

        console.log('Submitting data in Step 1:', {
            groupName: formData.groupName,
            category_name: formData.category_name,
            productName: formData.productName,
            hasVariant: formData.hasVariant,
            imagesCount: childImages.length,
            branch_id: formData.branch_id,
        });

        // ✅ FIX 3: Make the API call and store response properly
        const response = await postData('/product_add', formDataToSend, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
console.log("🚚 Delivery Type Data Sending to Backend:", {
  home_delivery: formData.home_delivery,
  take_away: formData.take_away,
  safe_delivery: formData.safe_delivery,
});
        // ✅ FIX 4: Safe response handling
        if (response?.data?.productId) {
            // Store the new product_id in state
            setNewProductId(response.data.productId);
            console.log("Product created successfully with ID:", response.data.productId);

            // Show success message
            showAlert({
                type: 'success',
                message: response.data.message || 'Product created successfully',
                title: 'Success',
            });

            // Refresh the product list
            fetchProdMasData();

            // Proceed to Step 2
            setActiveStep(2);
        } else {
            throw new Error('Product created but no ID returned');
        }

    } catch (error) {
        console.error('Submission error in Step 1:', error);

        // ✅ FIX 5: Safe error message extraction
        const errorMessage = error?.response?.data?.message || 
                            error?.message || 
                            'Failed to create product. Please try again.';

        showAlert({
            type: "error",
            message: errorMessage,
            title: "Error"
        });
    }
};
const handlestep2roduct = async () => {
  if (!newproductid) {
    showAlert({
      type: "warning",
      message: "Product ID is missing. Please complete Step 1 first.",
      title: "Warning",
    });
    return false;
  }

  try {
    await putData(`/product_has_variant/${newproductid}`, {
      hasVariant: hasVariant, // use ONLY hasVariant
    });

    showAlert({
      type: "success",
      message: "Product variant setting updated successfully",
      title: "Success",
    });

    return true; // ✅ tell caller it succeeded
  } catch (error) {
    showAlert({
      type: "error",
      message:
        error?.response?.data?.message ||
        "Failed to update product details",
      title: "Error",
    });

    return false;
  }
};


const fetchOptions = async () => {
      try {
        const productAttributes = attribute.filter(
          (f) => f.Attribute_Category === "Common"
        );
        const variantAttributes = attribute.filter(
          (f) => f.Attribute_Category === "Variant_Deterministic"
        );

        // Fetch product attribute options
        const productPromises = productAttributes.map(async (feature) => {
          const id=feature.id
          const res = await getData(`/productoption/${id}`);
          console.log('productoptions',res.data);
          return { feature, options: res.data };
        });

        // Fetch variant attribute options
        const variantPromises = variantAttributes.map(async (feature) => {
          const id=feature.id
          const res = await getData(`/productoption/${id}`);
          console.log('productoptions22',res.data);
          return { feature, options: res.data };
        });

        // Wait for all promises to resolve
        const productResults = await Promise.all(productPromises);
        const variantResults = await Promise.all(variantPromises);

        // Combine each feature with its options
        setProductAttrsWithOpts(
          productResults.map(({ feature, options }) => ({
            ...feature,
            options,
          }))
        );
        setVariantAttrsWithOpts(
          variantResults.map(({ feature, options }) => ({
            ...feature,
            options,
          }))
        );
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    };

const fetchattribute = async (groupId) => {
  if (!groupId) {
    setattribute([]);
    setError('please select user group')
    return;
  }
  try {
    setError(null);
    const res = await getData(`/getComponentMap/${groupId}`);
    console.log("api data")
    console.log(res)
    setattribute(res.data);
    
  } catch (err) {
    setError(err.message || 'Error fetching attribute');
  }
};

    const handleCancelAdd=()=>{
        setnewrender(false);
         setFormData(initialFormState);
        setChildImages([]);
        setActiveStep(1);
        setEditId(null);
        setActivePriceCard(0);
        setHasVariant(false);
        setSelectedvalues([]); 
        setCombos([]);  
        setNewProductId(null); 
        setSelectedGroupId(''); 
        setattribute([]);       
        setProductAttrsWithOpts([]); 
        setVariantAttrsWithOpts([]);
    }
    useEffect(()=>{
        console.log('has variant', hasVariant)
    },[hasVariant])

useEffect(()=>{
  console.log('seted product id ');
  console.log(newproductid);
},[newproductid]);

const handleUpdatePriceDetails = async () => {
  // Step 1 validation
  if (!newproductid) {
    showAlert({
      type: "warning",
      message: "Product ID is missing. Please complete Step 1 first.",
      title: "Warning",
    });
    return false;
  }

  // Mandatory field validation
  if (
    !formData.MRP || formData.MRP === "0" ||
    !formData.selling_Price || formData.selling_Price === "0"
  ) {
    showAlert({
      type: "info",
      message: "Please fill all mandatory details (MRP and Selling Price)",
      title: "Info",
    });
    return false;
  }

  try {
    const payload = {
      purchasePriceIncludeGST: formData.purchasePriceIncludeGST || "",
      selling_Price: formData.selling_Price || "",
      cgst_percent: formData.cgst_percent || "",
      cgst: formData.cgst || "",
      sgstPer: formData.sgstPer || "",
      sgst: formData.sgst || "",
      igstPer: formData.igstPer || "",
      igst: formData.igst || "",
      sellingPriceGST: formData.sellingPriceGST || "",
      discountPercent: formData.discountPercent || "",
      discountRetail: formData.discountAmount || "",
      netPriceRetail: formData.netPrice || "",
      MRP: formData.MRP || "",
      initial_stock: formData.initial_stock || "",
      height: formData.height || "",
      width: formData.width || "",
      breadth: formData.breadth || "",
      weight: formData.weight || "",
    };

    const response = await putData(`/product_price/${newproductid}`, payload);

    showAlert({
      type: "success",
      message: response?.data?.message || "Price details updated successfully",
      title: "Success",
    });

    fetchProdMasData();

    return true; // ✅ VERY IMPORTANT

  } catch (error) {
    console.error("Error updating price details:", error);

    showAlert({
      type: "error",
      message:
        error?.response?.data?.message ||
        error?.message ||
        "Failed to update price details.",
      title: "Error",
    });

    return false;
  }
};
    return (
        
         <div className="flex flex-col items-center min-h-screen min-w-full p-8 bg-gray-50 z-0">
            {!newrender && (
                            <div className="bg-white p-6 rounded-xl shadow-lg w-full overflow-x-auto mb-8">
                <div className="flex justify-between items-center mb-4"> 
                       <h2 className="text-2xl font-bold text-black">Master Product </h2>
                    <Button
                        variant="danger"
                        onClick={() => {
                            //setShowForm(true);
                            setEditId(null);
                            setFormData(initialFormState);
                            setChildImages([]);
                            setnewrender(true);
                            setShowForm(false);
                        }}
                        className='p-2 rounded-lg flex items-center space-x-2'
                    >
                        <FaPlus />
                        <span>Add Product Master</span>
                    </Button>
                </div>
                <div className="w-full border-collapse">
                    <GenericTable
                        columns={columns}
                        data={productdata}
                        customRenderers={customRenderers}
                        rowKey="product_id"
                        stripedRows={true}
                        hoverEffect={true}
                        headerClassName="bg-red-700 text-white"
                        
                    />
                </div>
            </div>
            )}
            {showForm && (
                <div className="w-full">
                    <Editproductmaster
                       formData={formData}
                       setFormData={setFormData}
                       editId={editId}
                       setEditId={setEditId}
                       childImages={childImages}
                       setChildImages={setChildImages}
                       handleCancel={handleCancel}
                       handleImagesUpdate={handleImagesUpdate}
                       mastereditid={mastereditid}
                    />
                </div>
            )}
            {newrender && (
    <div className="w-full mt-8">
        <div className="flex justify-between items-center mb-6">
             <h2 className="text-2xl font-bold text-black">Add New Product</h2>
                 <Button
                  onClick={handleCancelAdd} // Use the handler to go back
                  className="px-4 py-2 rounded-lg bg-orange-300 hover:bg-gray-300 text-black font-semibold"
                 >
                 ← Back to List
                 </Button>
                </div>
        {/* Stepper Buttons */}
        <div className="flex flex-row items-center w-full mb-6 gap-2 ">
            {[1, 2, 3, 4].map((step) => (
              <div key={step} className="flex items-center w-[100px] sm:flex-1">
                <button
                  onClick={() => setActiveStep(step)}
                  className={`w-full py-1 sm:py-3 text-xs sm:text-base text-center font-semibold rounded-md
                    ${activeStep === step ? 'bg-blue-600 text-white shadow-lg' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}
                  `}
                >
                  Step {step}
                </button>
                {step !== 4 && (
                  <svg
                    className={`w-4 h-4 sm:w-6 sm:h-6 mx-2 hidden sm:block transition-colors duration-300
                      ${activeStep > step ? 'text-blue-600' : 'text-gray-300'}`}
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                  </svg>
                )}
              </div>
            ))}
        </div>

        {/* --- Step 1 Content --- */}
        {editId && formData.productCode && (
    <div className="col-span-1">
        <label className="block text-gray-700 font-semibold mb-2">
            Product Code (Auto-generated)
        </label>
        <Input
            type="text"
            name="productCode"
            value={formData.productCode}
            disabled={true}
            className="bg-gray-100 cursor-not-allowed"
        />
    </div>
)}
        {activeStep === 1 && (
            <div className="bg-white p-6 rounded-xl shadow-lg w-full">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

                    {/* <div className="col-span-1">
                        <label htmlFor="title" className="block text-gray-700 font-semibold mb-2">Title</label>
                        <Input
                            type="text"
                            name="productName"
                            value={formData.productName}
                            onChange={handleChange}
                            placeholder="Enter Product Name"
                            required="true"
                            className={inputClassName}
                        />
                    </div> */}
{/* Title */}
<div className="col-span-1">
  <label className="block text-gray-700 font-semibold mb-2">
    Title
  </label>
  <Input
    type="text"
    name="productName"
    value={formData.productName}
    onChange={handleChange}
    placeholder="Enter Product Name"
    required
    className={inputClassName}
  />
</div>

{/* Region Dropdown */}
<div className="col-span-1 relative">
  <label className="block text-gray-700 font-semibold mb-2">
    Region
  </label>
  <Selectornew
    options={regionData?.map((region) => ({
      value: region.region_id,
      label: region.region_name,
    })) || []}
    value={regionSelect}
    onChange={(val) => {
      setRegionSelect(val);
      // setFormData({ ...formData, region_id: val });
      setFormData({ ...formData, region_id: val.value });
    }}
    placeholder="Select Region"
    required
  />
</div>

{/* Branch Dropdown */}
<div className="col-span-1 relative">
  <label className="block text-gray-700 font-semibold mb-2">
    Branch
  </label>
  <Selectornew
    options={branchData?.map((branch) => ({
      value: branch.branch_id,
      label: branch.branch_name,
    })) || []}
    value={branchSelect}
    onChange={(val) => {
      setBranchSelect(val);
      // setFormData({ ...formData, branch_id: val });
      setFormData({ ...formData, branch_id: val.value });
    }}
    placeholder="Select Branch"
    required
  />
</div>
                    <div className="col-span-1 md:col-span-2 lg:col-span-3">
                        <label className="block text-gray-700 font-semibold mb-2">Product Images</label>
                        <div className="bg-gray-50 p-4 rounded-lg shadow-md w-full">
                            <Productmasterimg
                                productId={editId}
                                onImagesUpdate={handleImagesUpdate}
                                initialImages={childImages}
                                key={editId || 'new'}
                            />
                        </div>
                    </div>
                    <div className="col-span-1 relative">
                        <label className="text-gray-700 font-semibold">Product Category</label>
                    <Selectornew
                        className="overflow-auto z-50"
                        options={category ? category
                            .map(group => ({
                                value: group.product_category_id,
                                label: group.parent_category_name  // Use the joined field
                                    ? `${group.parent_category_name} → ${group.category_name}`
                                    : group.category_name,
                            })) : []}
                        value={categoryselect}
                        onChange={(val) => {
                            setFormData({ ...formData, category_name: val });
                            setCategoryselect(val);
                        }}
                        placeholder="Select Product Category"
                        required
                    />
                    </div>
                    <div className="col-span-1 relative">
                        <label className="text-gray-700 font-semibold">Product Type</label>
                        <Selectornew
                            className="overflow-auto z-50"
                            options={product_typedata ? product_typedata
                                .map(group => ({
                                    value: group.product_type_id.toString(),
                                    label: group.product_type_name
                                })):[]}
                            value={formData.groupName?.toString()}
                            onChange={(value) => {
                                setFormData({ ...formData, groupName: value });
                                setSelectedGroupId(Number(value));
                            }}
                            placeholder="Select Product Type"
                            required
                        />
                    </div>

                    <div className="col-span-1 relative">
                    <label className="text-gray-700 font-semibold">GST Option</label>
                    <div className="flex items-center gap-6 mt-2">
                        <label className="flex items-center gap-2">
                        <input
                            type="radio"
                            name="gstType"
                            value="withGST"
                            checked={with_or_without_gst == 'withGST'}
                            onChange={handleChangeGstradio}
                            className="w-4 h-4 text-blue-600 border-gray-300"
                        />
                        <span>With GST</span>
                        </label>
                        <label className="flex items-center gap-2">
                        <input
                            type="radio"
                            name="gstType"
                            value="withoutGST"
                            checked={with_or_without_gst == 'withoutGST'}
                            onChange={handleChangeGstradio}
                            className="w-4 h-4 text-blue-600 border-gray-300"
                        />
                        <span>Without GST</span>
                        </label>
                    </div>
                    </div>

                    <div className="mb-4 pt-8">
                        <label className="inline-flex items-center">
                            <input type="checkbox" checked={hasVariant} onChange={(e) => setHasVariant(e.target.checked)}/>

                            <span className="ml-2 text-gray-700 font-semibold">Has Variant</span>
                        </label>
                    </div>
{/* <div className="col-span-1 md:col-span-2 lg:col-span-3">
  <label className="block text-gray-700 font-semibold mb-2">
    Delivery Options
  </label>

  <div className="flex flex-wrap gap-6">
    <label className="flex items-center gap-2">
      <input
        type="checkbox"
        checked={formData.home_delivery}
        onChange={(e) =>
          setFormData({ ...formData, home_delivery: e.target.checked })
        }
      />
      <span>Home Delivery</span>
    </label>

    <label className="flex items-center gap-2">
      <input
        type="checkbox"
        checked={formData.take_away}
        onChange={(e) =>
          setFormData({ ...formData, take_away: e.target.checked })
        }
      />
      <span>Take Away</span>
    </label>

    <label className="flex items-center gap-2">
      <input
        type="checkbox"
        checked={formData.safe_delivery}
        onChange={(e) =>
          setFormData({ ...formData, safe_delivery: e.target.checked })
        }
      />
      <span>Safe Delivery</span>
    </label>
  </div>
</div> */}
<div className="col-span-1 md:col-span-2 lg:col-span-3">
  <label className="block text-gray-700 font-semibold mb-2">
    Delivery Options
  </label>

  <div className="flex flex-col gap-4">
    {/* HOME DELIVERY */}
    <div className="flex items-center gap-4">
      <input
        type="checkbox"
        checked={formData.home_delivery}
        onChange={(e) =>
          setFormData({
            ...formData,
            home_delivery: e.target.checked,
            home_delivery_amount: e.target.checked
              ? formData.home_delivery_amount
              : "",
          })
        }
      />
      <span>Home Delivery</span>

      {formData.home_delivery && (
        <input
          type="number"
          placeholder="Amount"
          value={formData.home_delivery_amount}
          onChange={(e) =>
            setFormData({
              ...formData,
              home_delivery_amount: e.target.value,
            })
          }
          className="border rounded px-2 py-1 w-32"
        />
      )}
    </div>

    {/* TAKE AWAY */}
    <div className="flex items-center gap-4">
      <input
        type="checkbox"
        checked={formData.take_away}
        onChange={(e) =>
          setFormData({
            ...formData,
            take_away: e.target.checked,
            take_away_amount: e.target.checked
              ? formData.take_away_amount
              : "",
          })
        }
      />
      <span>Take Away</span>

      {formData.take_away && (
        <input
          type="number"
          placeholder="Amount"
          value={formData.take_away_amount}
          onChange={(e) =>
            setFormData({
              ...formData,
              take_away_amount: e.target.value,
            })
          }
          className="border rounded px-2 py-1 w-32"
        />
      )}
    </div>

    {/* SAFE DELIVERY */}
    <div className="flex items-center gap-4">
      <input
        type="checkbox"
        checked={formData.safe_delivery}
        onChange={(e) =>
          setFormData({
            ...formData,
            safe_delivery: e.target.checked,
            safe_delivery_amount: e.target.checked
              ? formData.safe_delivery_amount
              : "",
          })
        }
      />
      <span>Safe Delivery</span>

      {formData.safe_delivery && (
        <input
          type="number"
          placeholder="Amount"
          value={formData.safe_delivery_amount}
          onChange={(e) =>
            setFormData({
              ...formData,
              safe_delivery_amount: e.target.value,
            })
          }
          className="border rounded px-2 py-1 w-32"
        />
      )}
    </div>
  </div>
</div>
                    <div className="col-span-1 md:col-span-2 lg:col-span-3">
                    <label htmlFor="description" className="block text-gray-700 font-semibold mb-2">
                        Product Description (Bullet Points)
                    </label>
                    <textarea
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        placeholder="Enter each bullet point on a new line"
                        rows="5"
                        className="w-full border rounded-lg p-2"
                    />
                    </div>

                    <ul className="list-disc pl-6">
                        {formData.description?.split("\n").map((line, idx) => (
                            <li key={idx}>{line}</li>
                        ))}
                    </ul>

                </div>

                <div className="flex justify-end mt-6">
                    <Button
                        variant="primary"
                        className="px-6 py-2 rounded-md"
                        onClick={handleNextStep1}
                    >
                        Next →
                    </Button>
                </div>
            </div>
        )}

        {/* --- Step 2 Content --- */}
        {activeStep === 2 && (
            <div className="w-full px-4 py-6 rounded-xl shadow-lg bg-white space-y-6">
                <div className="flex flex-col gap-4">
                    {["Price", "Product", "Variant"].map((title, index) =>
                        ((index === 2 && !hasVariant) ? null : (
                            <div key={index} className="w-full">
                                {activePriceCard === index ? (
                                    <div className="bg-white p-4 sm:p-6 rounded-lg border border-gray-300 shadow-md">
                                        <h3 className="text-lg font-semibold mb-4">{title} Details</h3>
                                        {index === 0 ? (
                                            <div>
                                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                                {/* All your price inputs */}
                                                <div className="col-span-1"><Input type="text" label="Purchase Price Included GST" name="purchasePriceIncludeGST" value={formData.purchasePriceIncludeGST} onChange={handleChange} placeholder="Enter Purchase Price" labelColor="text-gray-700 font-semibold" className={inputClassName} /></div>
                                                <div className="col-span-1"><Input type="text" label="Selling Price" name="selling_Price" value={formData.selling_Price} onChange={handleChange} placeholder="Enter Selling Price" className={inputClassName} required="true" /></div>
                                                <div className="col-span-1"><Input type="text" label="MRP" name="MRP" value={formData.MRP} onChange={handleChange} placeholder="MRP" className={inputClassName} required="true" labelColor="text-gray-700 font-semibold" /></div>

                                                {/* CGST */}
                                                <div className="col-span-1">
                                                    <label className="text-gray-700 font-semibold">CGST</label>
                                                    <div className="flex items-center gap-2">
                                                        <Input
                                                        type="text"
                                                        name="cgst_percent"
                                                        value={formData.cgst_percent}
                                                        onChange={handleChange}
                                                        placeholder="0.00"
                                                        className={`${inputClassName} w-20`}
                                                        />
                                                        <span className="text-gray-600">%</span>
                                                        <Input
                                                        type="text"
                                                        name="cgst"
                                                        value={formData.cgst}
                                                        disabled
                                                        placeholder="0.00"
                                                        className={`${inputClassName} w-24 bg-gray-100`}
                                                        />
                                                        <span className="text-gray-600">₹</span>
                                                    </div>
                                                </div>

                                                {/* SGST */}
                                                <div className="col-span-1">
                                                    <label className="text-gray-700 font-semibold">SGST</label>
                                                    <div className="flex items-center gap-2">
                                                        <Input
                                                        type="text"
                                                        name="sgstPer"
                                                        value={formData.sgstPer}
                                                        onChange={handleChange}
                                                        placeholder="0.00"
                                                        className={`${inputClassName} w-20`}
                                                        />
                                                        <span className="text-gray-600">%</span>
                                                        <Input
                                                        type="text"
                                                        name="sgst"
                                                        value={formData.sgst}
                                                        disabled
                                                        placeholder="0.00"
                                                        className={`${inputClassName} w-24 bg-gray-100`}
                                                        />
                                                        <span className="text-gray-600">₹</span>
                                                    </div>
                                                </div>

                                                {/* IGST */}
                                                <div className="col-span-1">
                                                    <label className="text-gray-700 font-semibold">IGST</label>
                                                    <div className="flex items-center gap-2">
                                                        <Input
                                                        type="text"
                                                        name="igstPer"
                                                        value={formData.igstPer}
                                                        onChange={handleChange}
                                                        placeholder="0.00"
                                                        className={`${inputClassName} w-20`}
                                                        />
                                                        <span className="text-gray-600">%</span>
                                                        <Input
                                                        type="text"
                                                        name="igst"
                                                        value={formData.igst}
                                                        disabled
                                                        placeholder="0.00"
                                                        className={`${inputClassName} w-24 bg-gray-100`}
                                                        />
                                                        <span className="text-gray-600">₹</span>
                                                    </div>
                                                </div>

                                                {/* Discount */}
                                                <div className="col-span-1">
                                                    <label className="text-gray-700 font-semibold">Discount</label>
                                                    <div className="flex items-center gap-2">
                                                        <Input
                                                        type="text"
                                                        name="discountPercent"
                                                        value={formData.discountPercent}
                                                        onChange={handleChange}
                                                        placeholder="0.00"
                                                        className={`${inputClassName} w-20`}
                                                        />
                                                        <span className="text-gray-600">%</span>
                                                        <Input
                                                        type="text"
                                                        name="discountAmount"
                                                        value={formData.discountAmount}
                                                        disabled
                                                        placeholder="0.00"
                                                        className={`${inputClassName} w-24 bg-gray-100`}
                                                        />
                                                        <span className="text-gray-600">₹</span>
                                                    </div>
                                                </div>

                                                <div className="col-span-1"><Input type="text" label="Selling Price With GST" name="sellingPriceGST" value={formData.sellingPriceGST} onChange={handleChange} placeholder="0.00" className={inputClassName} required="true" labelColor="text-gray-700 font-semibold" /></div>
 
<div className="col-span-1">
    <Input 
        type="text" 
        label="Net Price" 
        name="netPrice" 
        value={formData.netPrice} 
        onChange={handleChange} 
        placeholder="Final Price" 
        required={false}
        labelColor="text-gray-700 font-semibold" 
        className={inputClassName} 
        disabled={true} 
    />
</div>

{!formData.hasVariant && (
  <div className="col-span-1">
      <Input 
          type="text" 
          label="Stock" 
          name="initial_stock" 
          value={formData.initial_stock} 
          onChange={handleChange} 
          placeholder="Enter stock" 
          required={true} 
          labelColor="text-gray-700 font-semibold" 
          className={inputClassName}  
      />
  </div>
)}
</div>

<div className="mt-6">
    
    <h1 className="text-lg font-semibold text-gray-800 mb-2">Dimension</h1>
     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
<div className="col-span-1">
    <Input 
        type="text" 
        label="Height(cm)" 
        name="height" 
        value={formData.height} 
        onChange={handleChange} 
        placeholder="Enter height" 
        required="true" 
        labelColor="text-gray-700 font-semibold" 
        className={inputClassName}  
    />
</div>
<div className="col-span-1">
    <Input 
        type="text" 
        label="Width(cm)" 
        name="width" 
        value={formData.width} 
        onChange={handleChange} 
        placeholder="Enter width" 
        required="true" 
        labelColor="text-gray-700 font-semibold" 
        className={inputClassName}  
    />
</div>
<div className="col-span-1">
    <Input 
        type="text" 
        label="Breadth(cm)" 
        name="breadth" 
        value={formData.breadth} 
        onChange={handleChange} 
        placeholder="Enter breadth" 
        required="true" 
        labelColor="text-gray-700 font-semibold" 
        className={inputClassName}  
    />
</div>

<div className="col-span-1">
    <Input 
        type="text" 
        label="Weight(grams)" 
        name="weight" 
        value={formData.weight} 
        onChange={handleChange} 
        placeholder="Enter weight" 
        required="true" 
        labelColor="text-gray-700 font-semibold" 
        className={inputClassName}  
    />
</div>
</div>
</div>
                                            </div>
                                        ) : index === 1 ? (
                                            <div>
                                                <div className="bg-white p-4 rounded-lg border border-gray-300 shadow-md">
                                                    {productAttrsWithOpts.length > 0 ? (
                                                        <div className="space-y-6">
                                                            {productAttrsWithOpts.map((feature) => (
                                                                <Inputfield key={feature.attribute_id} type={feature.Attribute_Type} label={feature.attribute_name} name={feature.attribute_id} options={feature.options?.map(opt => opt.option) || []} selectedValues={selectedvalues} setSelectedValues={setSelectedvalues} required={true} Attribute_Category={feature.Attribute_Category} Parent_Variant_Id={feature.Parent_Variant_Id} Attribute_Type={feature.Attribute_Type} ide={feature.id}/>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <p className="text-gray-500">No product attributes available.</p>
                                                    )}
                                                </div>
                                                {/* <div className="mb-4 pt-8">
                                                    <label className="inline-flex items-center">
                                                        <input type="checkbox" className="form-checkbox h-4 w-4 text-blue-600" checked={formData.hasVariant} onChange={(e) => { const newValue = e.target.checked; setHasVariant(newValue); setFormData((prev) => ({ ...prev, hasVariant: newValue })); }} />
                                                        <span className="ml-2 text-gray-700 font-semibold">Has Variant</span>
                                                    </label>
                                                </div> */}
                                            </div>
                                        ) : (
                                            <div className="bg-white p-4 rounded-lg border border-gray-300 shadow-md">
                                                {variantAttrsWithOpts.length > 0 ? (
                                                    <div className="space-y-6">
                                                        {variantAttrsWithOpts.map((feature) => (
                                                            <Inputfield key={feature.attribute_id} type={feature.Attribute_Type} label={feature.attribute_name} name={feature.attribute_id} options={feature.options?.map(opt => opt.option) || []} selectedValues={selectedvalues} setSelectedValues={setSelectedvalues} required={true} Attribute_Category={feature.Attribute_Category} ID={feature.id} Parent_Variant_Id={feature.Parent_Variant_Id} Attribute_Type={feature.Attribute_Type}ide={feature.id} />
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <p className="text-gray-500">No Variant attributes available.</p>
                                                )}
                                            </div>
                                        )}
                                        <div className="flex justify-end mt-6">
                                           <Button
  variant="primary"
  className="px-6 py-2 rounded-md"
  onClick={async () => {

    // PRICE → PRODUCT
    if (index === 0) {
      const ok = await handleUpdatePriceDetails();
      if (ok) {
        setActivePriceCard(1);
      }
      return;
    }

    // PRODUCT → VARIANT or STEP 3
    if (index === 1) {
      const ok = await handlestep2roduct();
      if (!ok) return;

      if (hasVariant) {
        setActivePriceCard(2);   
      } else {
        setActivePriceCard(null);
        setActiveStep(4);       
      }
      return;
    }

    // VARIANT → STEP 3
    if (index === 2) {
      setActivePriceCard(null);
      setActiveStep(3);
    }
  }}
>
  Next →
</Button>



                                        </div>
                                    </div>
                                ) : (
                                    <div className="flex justify-between items-center p-4 border rounded-lg shadow-sm cursor-pointer transition bg-white hover:bg-gray-100" onClick={() => setActivePriceCard(index)}>
                                        <span className="font-medium text-gray-800">{title}</span>
                                        <span className="text-2xl font-bold text-blue-600">+</span>
                                    </div>
                                )}
                            </div>
                        ))
                    )}
                </div>
            </div>
        )}

        {/* --- Step 3 Content (THE IMPORTANT FIX) --- */}
        {activeStep === 3 && (
            <Step3
                selectedvalues={selectedvalues}
                combos={combos}
                setCombos={setCombos}
                attribute={attribute}
                newproductid={newproductid}  // This now passes the correct, current state value
                onSaveComplete={handleVariantSaveComplete}
                hasVariant={hasVariant}
            />
        )}

        {/* --- Step 4 Content --- */}
        {activeStep === 4 && (
             <Step4 id={encodeId(newproductid)} type="Add Product" handleCancelAdd={handleCancelAdd}/>
        )}
    </div>
)}
 </div> 
 
        
    );
};

export default ProductMaster;